/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UmbrellaCompanyResource
 */
export interface UmbrellaCompanyResource {
    /**
     * 
     * @type {string}
     * @memberof UmbrellaCompanyResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UmbrellaCompanyResource
     */
    companyTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof UmbrellaCompanyResource
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UmbrellaCompanyResource
     */
    zipCode: string;
}

/**
 * Check if a given object implements the UmbrellaCompanyResource interface.
 */
export function instanceOfUmbrellaCompanyResource(value: object): value is UmbrellaCompanyResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyTypeId' in value) || value['companyTypeId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    return true;
}

export function UmbrellaCompanyResourceFromJSON(json: any): UmbrellaCompanyResource {
    return UmbrellaCompanyResourceFromJSONTyped(json, false);
}

export function UmbrellaCompanyResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UmbrellaCompanyResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyTypeId': json['companyTypeId'],
        'name': json['name'],
        'zipCode': json['zipCode'],
    };
}

export function UmbrellaCompanyResourceToJSON(value?: UmbrellaCompanyResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'companyTypeId': value['companyTypeId'],
        'name': value['name'],
        'zipCode': value['zipCode'],
    };
}

